import axios from "@/api/config";
const examStudent = {
  //获取考试系统考试学员列表
  getSystemMemberList(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationStudentInfo/pageList`,
      data
    );
  },
  pageList(data) {
    // return axios.post(`${process.env.BASE_URL}/examinationStudentInfo/pageList`, data)
    return axios.post(`${process.env.BASE_URL}/examStudent/pageList`, data);
  },
  //查看系统考试学员信息
  getSystemStuDetailInfo(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationStudentInfo/studentInfoDetail`,
      data
    );
  },
  getExamResultPageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/examStudent/getExamResultPageList`,
      data
    );
  },
  getExamStudentData(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationStudentInfo/getExaminationInfoPageList`,
      data
    );
  },
  getSystemStudentResult(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationStudent/queryExamResult`,
      data
    );
  },
  addExamStudent(data) {
    return axios.post(
      `${process.env.BASE_URL}/examStudent/addExamStudent`,
      data
    );
  },
  updateExamStudent(data) {
    return axios.put(
      `${process.env.BASE_URL}/examStudent/updateExamStudent`,
      data
    );
  },
  deleteExamStudent(data) {
    return axios.delete(
      `${process.env.BASE_URL}/examStudent/deleteExamStudent`,
      {
        data: data
      }
    );
  },
  getClassroomList(data) {
    return axios.get(`${process.env.BASE_URL}/classroom/getClassroomList`, {
      params: data
    });
  },
  getClassroomTree(data) {
    return axios.get(`${process.env.BASE_URL}/classroom/getClassroomTree`, {
      params: data
    });
  },
  getHistoryExercise(data) {
    return axios.get(`${process.env.BASE_URL}/examStudent/getHistoryExercise`, {
      params: data
    });
  },
  exportExamResultExcel(data) {
    return axios.post(
      `${process.env.BASE_URL}/examStudent/exportExamResultExcel`,
      data
    );
  },
  getExerciseResultById(data) {
    return axios.post(
      `${process.env.BASE_URL}/examStudent/getExerciseResultById`,
      data
    );
  },
  simulateGetExamSettingInfo(data) {
    return axios.get(
      `${process.env.BASE_URL}/examStudent/simulateGetExamSettingInfo`,
      {
        params: data
      }
    );
  },
  getSubjectiveExamResultPageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/examStudent/getSubjectiveExamResultPageList`,
      data
    );
  },
  // 考试系统审批列表
  systemAuditData(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationStudent/getSubjectiveExamApprovePageList`,
      data
    );
  },
  getSubjectiveQuestionByExerciseId(data) {
    return axios.get(
      `${process.env.BASE_URL}/examStudent/getSubjectiveQuestionByExerciseId`,
      { params: data }
    );
  },
  getSubjectiveExamResultCount(data) {
    return axios.post(
      `${process.env.BASE_URL}/examStudent/getSubjectiveExamResultCount`,
      data
    );
  },
  getSystemResultCount(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationStudent/getSubjectiveExamResultCount`,
      data
    );
  },
  getSystemResultCount(data) {
    return axios.post(
      `${process.env.BASE_URL}/examinationStudent/getSubjectiveExamResultCount`,
      data
    );
  }
};
export default examStudent;



// WEBPACK FOOTER //
// ./src/api/examStudent.js